export const getDurationUnit = (duration: number, unit: 'hours' | 'minutes', abbreviated = false) => {
  if (abbreviated) {
    return duration > 1 ? (unit === 'hours' ? 'hrs' : 'mins') : unit === 'hours' ? 'hr' : 'min'
  } else {
    return duration > 1 ? unit : unit === 'hours' ? 'hour' : 'minute'
  }
}

export const getTimeAgo = (timestamp: Date, compact: boolean = false): string => {
  const now = new Date()
  const date = new Date(timestamp)
  const diffInMilliseconds = now.getTime() - date.getTime()
  const diffInMinutes = Math.floor(diffInMilliseconds / (1000 * 60))
  const diffInHours = Math.floor(diffInMilliseconds / (1000 * 60 * 60))
  const diffInDays = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24))

  if (diffInMinutes < 1) {
    return compact ? 'now' : 'Moments ago'
  } else if (diffInMinutes < 60) {
    return compact ? `${diffInMinutes}m` : `${diffInMinutes} ${getDurationUnit(diffInMinutes, 'minutes')} ago`
  } else if (diffInHours < 24) {
    return compact ? `${diffInHours}h` : `${diffInHours} ${getDurationUnit(diffInHours, 'hours')} ago`
  } else {
    return compact ? `${diffInDays}d` : `${diffInDays} day${diffInDays > 1 ? 's' : ''} ago`
  }
}

export const getWordCount = (text: string) => text.trim().split(/\s+/).length
export const getWordCountFormatted = (text: string) => getWordCount(text).toLocaleString()

export const hasNonWhitespaceCharacters = (str: string): boolean => {
  return str.replace(/\s/g, '').length > 0
}

/**
 * Orders strings by UTF-16 code unit — what a bare `.sort()` already does, stated
 * explicitly to satisfy SonarQube S2871.
 *
 * Preferred over `localeCompare` for canonical keys and equality checks: collation
 * varies by locale and ICU version, and it reports 0 for strings that differ only
 * by accent or normalization, which leaves their order down to input order and so
 * makes the "canonical" form depend on how it was built. Sort with `localeCompare`
 * only for text a user actually reads.
 */
export const compareCodeUnits = (a: string, b: string): number => (a < b ? -1 : a > b ? 1 : 0)

// Helper function to format date for conversation
export const formatDateForConversation = (date: number | string | Date): string => {
  if (date === undefined) return ''
  if (typeof date === 'number') return new Date(date).toISOString()
  if (typeof date === 'string') return date
  return date.toISOString()
}
